import React from "react";
import SearchComponent from "../SearchComponent";
import { BottomSheet } from "react-spring-bottom-sheet";
import "./BottomSearchSheetForList.scss";

const BottomSearchSheetForList = (props) => {
  const {
    show,
    className,
    hideCity,
    showBottomSheet,
    setShowBottomSheet,
    state,
    setState,
    searchHotels,
    searchDestinations,
  } = props;

  return (
    <BottomSheet
      open={show}
      onDismiss={() => setShowBottomSheet(false)}
      className={className}
    >
      <SearchComponent
        state={state}
        hideCity={hideCity}
        showBottomSheet={showBottomSheet}
        setShowBottomSheet={setShowBottomSheet}
        setState={setState}
        searchHotels={searchHotels}
        searchDestinations={searchDestinations}
        cityError={props.cityError}
      />
    </BottomSheet>
  );
};

export default BottomSearchSheetForList;
